import { render, staticRenderFns } from "./TheFields.vue?vue&type=template&id=06384d36"
import script from "./TheFields.vue?vue&type=script&lang=js"
export * from "./TheFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports